import { IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ReactElement } from 'react';
import styles from './styles.module.css';

type HeaderProps = {
    showTitle?: boolean;
    upperLabel?: string | any;
    lowerLabel?: string | any;
    titles?: any[];
    type: string;
    icon?: any;
    onClick?: any;
    template: (v: any, i?: any) => ReactElement;
    width?: string;
    maxWidth?: string;
    align?: 'right' | 'left' | 'center' | 'justify' | 'char' | undefined;
    noStyle?: boolean;
};

interface Props {
    header: HeaderProps;
    item: any;
    index: number;
    onSelectRow: any;
    menuOpen: boolean;
    selected: any;
    selectedItemFromAction: any;
}

function DataTableCell({ header, item, index, menuOpen, selectedItemFromAction }: Props) {
    const isItemSelected = item?.id === selectedItemFromAction?.id;
    const hasMaxWidth = header?.maxWidth !== undefined && header?.maxWidth !== '';
    
    const DataCell = () => (
        <>
            <div style={{ width: '100%' }}>
                <table style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            <td 
                                align={header?.align || 'left'} 
                                className={hasMaxWidth ? styles['cell-content-with-max-width'] : ''}
                            >
                                {typeof header?.upperLabel === 'function'
                                    ? header?.upperLabel(item)
                                    : item[header?.upperLabel]}
                            </td>
                            <td 
                                align={header?.align || 'left'}
                                className={hasMaxWidth ? styles['cell-content-with-max-width'] : ''}
                            >
                                {typeof header?.lowerLabel === 'function'
                                    ? header?.lowerLabel(item)
                                    : item[header?.lowerLabel]}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );

    /*  ${ &menuOpen& isItemSelected ? styles['iconbtn-active'] : ''} */

    const ActionCell = () => (
        <IconButton className={`${styles['iconbtn-m']} `} aria-label="menuOpciones"
            sx={{
                border: (theme) => menuOpen && isItemSelected ? `1.5px solid ${theme.palette.primary.main}` : '1px solid #E0EBED',
                outline: (theme) => menuOpen && isItemSelected ? `1.5px solid ${theme.palette.primary.main}` : '1px solid #E0EBED'
            }}>
            {header?.icon ? header.icon : <KeyboardArrowDownIcon />}
        </IconButton>
    );

    const ElementCell = () => (
        <div style={{ width: '100%' }}>
            <table style={{ width: '100%' }}>
                <tbody>
                    <td className={hasMaxWidth ? styles['cell-content-with-max-width'] : ''}>
                        {header.template(item, index)}
                    </td>
                </tbody>
            </table>
        </div>
    );

    const SelectionCell = () => (
        <IconButton className={styles['iconbtn-m']} aria-label="selectionCell">
            {header.template(item, index)}
        </IconButton>
    );

    function RenderTd() {
        switch (header?.type) {
            case 'selection':
                return <SelectionCell />;
            case 'action':
                return <ActionCell />;
            case 'element':
                return <SelectionCell />;
            case 'presentation-options':
                return <DataCell />;
            default:
                return <DataCell />;
        }
    }

    return <RenderTd />;
}

export default DataTableCell;
